










































import { defineComponent } from '@vue/composition-api';

import { useAdvisorSearchPagination } from '@/modules/advisor-search/organisms/AdvisorSearchPagination';

export default defineComponent({
  name: 'AdvisorSearchPagination',
  props: {
    query: {
      type: String,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    totalPage: {
      type: Number,
      required: true,
    },
    maxIntervalFromStartPage: {
      type: Number,
      default: 4,
    },
    limitOfShowPages: {
      type: Number,
      default: 10,
    },
  },
  setup(props) {
    const {
      firstPage,
      lastPage,
      prevPage,
      nextPage,
      pages,
      showPrevButton,
      showNextButton,
      path,
    } = useAdvisorSearchPagination(props);
    return {
      firstPage,
      lastPage,
      prevPage,
      nextPage,
      pages,
      showPrevButton,
      showNextButton,
      path,
    };
  },
});
